import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { BannerLogo } from 'Components/BannerLogo';

export const Banner = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				width: '100%'
			}}
		>
			
			<BannerLogo />
			<Typography
				variant='h4'
				component='h1'
				fontWeight='medium'
				sx={{
					marginTop: 0.5
				}}
			>
				NFT STUDIO MARKETPLACE
			</Typography>
			<Typography
				variant='caption'
				textAlign='center'
				sx={{
					marginTop: 0.5,
					width: '50%'
				}}
			>
				 NFT Studio's NFT Marketplace is a marketplace unlike any other.

						Rare, Extraordinary NFTs, and a fine selection of curated collections find their way here. Our users enjoy collections that delight and brilliantly showcase the capabilities of the Internet Computer.
                        
                        Stock updated weekly.
			</Typography>
		</Box>
	);
};
